<template>
  <v-col xs="12" sm="12" md="10" lg="8" xl="8">
    <v-card flat class="mx-8 mb-8">
      <v-card-title class="text-h5">Results</v-card-title>
      <v-card-subtitle>Blablabla.</v-card-subtitle>

      <v-card-text class="pt-4">
        <v-expansion-panels v-model="panel" multiple focusable>
          <v-expansion-panel class="elevation-4">
            <v-expansion-panel-header>Graphics</v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <v-row>
                <v-col>
                  <vx-graphics ref="graphics" width="100%" :graphicsData="graphicsData"/>
                  <v-btn color="primaryLight" dark block @click="downloadFile(csvFile)">
                    <v-icon left>mdi-download</v-icon>
                    Download CSV
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="elevation-4 mt-4">
            <v-expansion-panel-header>Regression model</v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <v-row>
                <v-col>
                  <v-textarea v-model="regressionSummary" readonly filled height="630px" class="text-body-1" no-resize/>
                  <v-btn color="primaryLight" dark block @click="downloadFile(aicFile)">
                    <v-icon left>mdi-download</v-icon>
                    Download AIC
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="elevation-4 mt-4">
            <v-expansion-panel-header>Files</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list subheader two-line rounded>
                <div v-for="(item, index) in filesList" :key="index">
                  <v-subheader>
                    Module {{item.module}}
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-5" icon v-bind="attrs" v-on="on" @click="viewAllModuleFiles(item.module)">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Load all files from module</span>
                    </v-tooltip> -->
                  </v-subheader>
                  <vx-result-file-list class="mt-2" :fileList="item.files"/>
                  <v-divider v-if="index !== (filesList.length - 1)"/>
                </div>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="elevation-4 mt-4">
            <v-expansion-panel-header>Report</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-btn class="mt-4" color="primaryLight" dark block @click="downloadFile(reportFile)">
                  <v-icon left>mdi-download</v-icon>
                  Download Report
                </v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ResultFileList from './ResultFileList.vue'
import Graphics from './Graphics.vue'

export default {
  name: 'Results',

  props: {
    currentProcess: String
  },

  components: {
    'vx-result-file-list': ResultFileList,
    'vx-graphics': Graphics
  },

  data: () => ({
    panel: []
  }),

  computed: {
    ...mapGetters('currentProcess', [
      'graphicsData',
      'csvFile',

      'regressionSummary',
      'aicFile',

      'mod1Files',
      'mod2Files',
      'mod3Files',
      'mod4Files',
      'reportFile'
    ]),

    filesList () {
      return [
        /* {
          module: 1,
          files: this.mod1Files
        }, */
        {
          module: 2,
          files: this.mod2Files
        },
        /* {
          module: 3,
          files: this.mod3Files
        }, */
        {
          module: 4,
          files: this.mod4Files
        }
      ]
    }
  },

  watch: {
  },

  methods: {
    ...mapActions('file', [
      'downloadFile'
    ])

    /* viewAllModuleFiles (module) {
      console.log(module)
    } */
  },

  mounted () {
  }
}
</script>

<style scoped>
</style>
